<template>
  <div style="padding: 40px 0;">
    <div class="company-core-account">
      <h1 class="account-title">账号管理</h1>

      <div class="register-info" v-if="$store.state.userInfo">
        <h2 class="title">注册信息</h2>
        <div class="info-label">
          <span class="info-label-key">注册邮箱:</span>
          <span v-html="accountMailDisplay" ref="mail"></span>
        </div>
        <div class="info-label">
          <span class="info-label-key">注册手机:</span>
          <span v-html="accountTelDisplay" ref="tel"></span>
        </div>
      </div>

      <div class="identity-info">
        <h2 class="title">身份信息</h2>
        <component :is="auditComponent"></component>
      </div>
    </div>
  </div>
</template>

<script>
import Audit from '@/components/companyCoreAccount/audit'
import Resolve from '@/components/companyCoreAccount/resolve'
import Reject from '@/components/companyCoreAccount/reject'
import UnSubmit from '@/components/companyCoreAccount/unsubmit'
import { login } from '@/utils/login'

export default {
  name: 'account',
  created() {
    if (this.$store.state.userInfo) {
      this.renderCompanyCoreAccount()
      this.$LogReport.sendCustomEvent('openplat_accountmanage_page_load')
    } else {
      this.$router.push({
        name: 'home'
      })
      login()
    }
  },
  components: {
    Audit,
    Resolve,
    Reject,
    UnSubmit
  },
  data() {
    return {
      /**
       * bind_mail: true
       bind_tel: true
       hide_mail: "kyo****@yeah.net"
       hide_tel: "189*****362"
       mail_verify: true
       tel_verify: true
       */
      account_info: null
    }
  },
  computed: {
    accountMailDisplay() {
      if (!this.account_info) return '...'
      if (!this.account_info.bind_mail) return `<a href="//${this.$bili_arcopen.isUAT ? 'uat-' : ''}passport.bilibili.com/account/security#/home" target="_blank">未绑定</a>`
      if (!this.account_info.mail_verify) return `<a href="//${this.$bili_arcopen.isUAT ? 'uat-' : ''}passport.bilibili.com/account/security#/home" target="_blank">未验证</a>`
      return this.account_info.hide_mail
    },
    accountTelDisplay() {
      if (!this.account_info) return '...'
      if (!this.account_info.bind_tel) return `<a href="//${this.$bili_arcopen.isUAT ? 'uat-' : ''}passport.bilibili.com/account/security#/home" target="_blank">未绑定</a>`
      if (!this.account_info.tel_verify) return `<a href="//${this.$bili_arcopen.isUAT ? 'uat-' : ''}passport.bilibili.com/account/security#/home" target="_blank">未验证</a>`
      return this.account_info.hide_tel
    },
    auditComponent() {
      if (!this.$store.state.companyInfo) return 'UnSubmit'
      if (this.$store.state.companyInfo.state === 0) return 'Audit'
      if (this.$store.state.companyInfo.state === 1) return 'Resolve'
      if (this.$store.state.companyInfo.state === 2) return 'Reject'
      return 'UnSubmit'
    }
  },
  methods: {
    renderCompanyCoreAccount() {
      this.$api.user
        .passportInfo()
        .then((data) => {
          this.account_info = data.account_info
          this.$nextTick(()=>{
            if (this.account_info && (!this.account_info.bind_tel || !this.account_info.tel_verify)){
              this.$refs['tel'].addEventListener('click',()=>{
                this.$LogReport.sendCustomEvent('openplat_accountmanage_phone_click')
              })
            }
            if (this.account_info && (!this.account_info.bind_mail || !this.account_info.mail_verify)){
              this.$refs['mail'].addEventListener('click',()=>{
                this.$LogReport.sendCustomEvent('openplat_accountmanage_email_click')
              })
            }
          })
        })
        .catch((e) => {
          console.error(e)
          this.$message({
            content: '获取注册信息失败: passport.bilibili.com/web/site/user/info',
            type: 'exception'
          })
        })
    }
  }
}
</script>

<style scoped lang="scss">
.company-core-account {
  min-width: 960px;
  width: 100%;
  max-width: 1168px;
  margin: 0 auto;
  box-sizing: border-box;
  border: 1px solid #e7e7e7;

  .account-title {
    padding: 20px 26px;
    box-shadow: inset 0 -1px 0 0 #e7e7e7;
    font-size: 24px;
    color: #212121;
  }

  .register-info,
  .identity-info {
    padding: 15px 26px 35px;
    .title {
      padding: 16px 35px;
      box-shadow: inset 0 -1px 0 0 #e7e7e7;
      font-size: 14px;
      color: #222222;
    }
    .info-label {
      padding: 16px 35px 0;
      font-size: 14px;
      color: #505050;
      line-height: 22px;

      .info-label-key {
        width: 180px;
        display: inline-block;
      }
    }
  }
}
</style>
